// This function allow to reference async chunks and sibling chunks for the entrypoint
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1274":"510a7ddd0e1987198cec","8078":"a4260b06f1454becf5c9"}[chunkId] + ".js";
};